import { Edit, ShowButton, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./SaveForm";

const handleSend = ({ options, ...rest }) => ({
  ...rest,
  options: Array.isArray(options) ? options.map(({ id, ...option }) => option) : options,
});

const EditCurriculumSelectionCampaign = () => {
  return (
    <Edit
      title="Редакция на кампания за избор на учебен план"
      mutationMode="pessimistic"
      transform={handleSend}
      actions={
        <BackButtonToolbar
          additionalButton={
            <ShowButton
              variant="contained"
              size="medium"
            />
          }
        />
      }
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Edit>
  );
};

export default EditCurriculumSelectionCampaign;
